import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IAddComplaintOptions } from '../../../../../api/complaint';
import { IState } from '../../../../../store';
import { addComplaint } from '../../../../../store/complaint/add_complaint';
import { ComplaintItem, IComplaintItemProps } from './index';

type TStoreFields = Pick<IComplaintItemProps, 'agent' | 'offer'>;
type TActions = Pick<IComplaintItemProps, 'addComplaint'>;
type TOwnProps = Pick<IComplaintItemProps, 'step' | 'complaint' | 'index' | 'isSelected' | 'onSelect'>;

/* istanbul ignore next */
function mapStateToProps(state: IState): TStoreFields {
  return {
    agent: state.offerData.agent,
    offer: state.offerData.offer,
  };
}

/* istanbul ignore next */
function mapDispathToProps(dispatch: Dispatch<IState>): TActions {
  return {
    addComplaint: (options: IAddComplaintOptions) => dispatch(addComplaint(options)),
  };
}

export const ComplaintItemContainer = connect<TStoreFields, TActions, TOwnProps>(
  mapStateToProps,
  mapDispathToProps,
)(ComplaintItem);
